<template>
  <div>
    <!-- Start Action Button -->
    <button
      type="button"
      class="tag-action-btn"
      :disabled="selectedCount === 0"
      @click="handleChangeTag"
    >
      <svg
        width="17"
        height="17"
        viewBox="0 0 17 17"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M3.75 4.58333C3.75 4.80435 3.8378 5.01631 3.99408 5.17259C4.15036 5.32887 4.36232 5.41667 4.58333 5.41667C4.80435 5.41667 5.01631 5.32887 5.17259 5.17259C5.32887 5.01631 5.41667 4.80435 5.41667 4.58333C5.41667 4.36232 5.32887 4.15036 5.17259 3.99408C5.01631 3.8378 4.80435 3.75 4.58333 3.75C4.36232 3.75 4.15036 3.8378 3.99408 3.99408C3.8378 4.15036 3.75 4.36232 3.75 4.58333Z"
          stroke="currentColor"
          stroke-width="1.66667"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M0.833496 7.64301V3.33301C0.833496 2.66997 1.09689 2.03408 1.56573 1.56524C2.03457 1.0964 2.67045 0.833008 3.3335 0.833008H7.6435C8.08549 0.833102 8.50934 1.00876 8.82183 1.32134L15.2468 7.74634C15.6234 8.12297 15.835 8.63375 15.835 9.16634C15.835 9.69893 15.6234 10.2097 15.2468 10.5863L10.5868 15.2463C10.2102 15.6229 9.69942 15.8345 9.16683 15.8345C8.63424 15.8345 8.12346 15.6229 7.74683 15.2463L1.32183 8.82134C1.00925 8.50885 0.83359 8.085 0.833496 7.64301Z"
          stroke="currentColor"
          stroke-width="1.66667"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>

      <span>Ubah tag yang dipilih</span>
    </button>
    <!-- End Action Button -->

    <!-- Start Modal -->
    <div
      class="modal fade payment-tag-modal-wrapper"
      id="modalChangePaymentTag"
      tabindex="-1"
      role="dialog"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content payment-tag-modal">
          <!-- Header -->
          <div class="modal-header">
            <div
              class="w-100 d-flex justify-content-between align-items-center"
            >
              <div class="flex-grow-1">
                <h5 class="modal-title-custom mb-0">Ubah Tag Pembayaran</h5>
                <p class="modal-subtitle-custom mb-0">
                  {{ selectedCount }} order terpilih dari {{ totalCount }}
                </p>
              </div>
              <button
                @click="resetModalForm"
                type="button"
                class="close mr-1"
                data-dismiss="modal"
              >
                <span>&times;</span>
              </button>
            </div>
          </div>

          <!-- Body -->
          <div class="modal-body-custom">
            <label
              class="option-card"
              :class="{ 'option-card--selected': tagOption === 'old' }"
            >
              <input
                type="radio"
                class="option-radio"
                name="tagOption"
                value="old"
                v-model="tagOption"
              />
              <span class="radio-visual"></span>
              <span class="option-text">
                <span class="option-title">Ikuti Tag Order Lama</span>
                <span class="option-desc"
                  >Pakai aturan yang sudah berjalan di order sebelum
                  pindah</span
                >
              </span>
            </label>

            <label
              class="option-card"
              :class="{ 'option-card--selected': tagOption === 'custom' }"
            >
              <input
                type="radio"
                class="option-radio"
                name="tagOption"
                value="custom"
                v-model="tagOption"
              />
              <span class="radio-visual"></span>
              <span class="option-text">
                <span class="option-title">Atur Sendiri</span>
                <span class="option-desc"
                  >Pilih cara hitung, waktu tagih, dan tanggal tagih secara
                  manual</span
                >
              </span>
            </label>

            <div
              v-if="tagOption === 'custom'"
              class="option-card"
              style="cursor: default"
            >
              <order-tag-form ref="orderTagFormRef" />
            </div>

            <label
              class="apply-all-row"
              :class="{ 'apply-all-row--checked': applyToAll }"
            >
              <input
                type="checkbox"
                class="apply-all-checkbox"
                v-model="applyToAll"
              />
              <span class="checkbox-visual">
                <svg
                  v-if="applyToAll"
                  width="24"
                  height="24"
                  viewBox="0 0 12 12"
                  fill="none"
                >
                  <path
                    d="M2.5 6.2L4.8 8.5L9.5 3.5"
                    stroke="#fff"
                    stroke-width="1.8"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </span>
              <span class="apply-all-text"
                >Terapkan ke semua order (bukan hanya order yang dipilih)</span
              >
            </label>

            <template v-if="applyToAll">
              <div class="info-box info-box--success">
                {{ selectedCount }} order terpilih - akan mengikuti
                {{
                  tagOption === "old"
                    ? "tag order lama"
                    : "tag yang diatur sendiri"
                }}
              </div>
              <div v-if="otherCount > 0" class="info-box info-box--warning">
                {{ otherCount }} order lain (tidak dipilih) - akan ikut berubah
                mengikuti
                {{
                  tagOption === "old"
                    ? "tag order lama"
                    : "tag yang diatur sendiri"
                }}
              </div>
            </template>
          </div>

          <!-- Footer -->
          <div class="modal-footer d-flex justify-content-end">
            <button
              type="button"
              class="btn btn-outline-secondary-custom"
              data-dismiss="modal"
              @click="resetModalForm"
            >
              Kembali
            </button>
            <button
              type="button"
              class="btn btn-primary-custom ml-2"
              @click="submit"
            >
              {{
                applyToAll
                  ? "Terapkan ke semua order"
                  : "Terapkan ke order terpilih"
              }}
            </button>
          </div>
        </div>
      </div>
    </div>
    <!-- End Modal -->
  </div>
</template>

<script>
import OrderTagForm from "./OrderTagForm.vue";
import { alert } from "@/utils";
import { mapActions, mapMutations } from "vuex";
import mixin from "../../mixin.js";

export default {
  name: "ChangePaymentTagModal",

  components: {
    OrderTagForm,
  },

  mixins: [mixin],

  props: {
    selectedCount: {
      type: Number,
      default: 0,
    },
    totalCount: {
      type: Number,
      default: 0,
    },
    orders: {
      type: Array,
      default: () => [],
    },
  },

  data() {
    return {
      tagOption: "old",
      applyToAll: false,
    };
  },

  computed: {
    otherCount() {
      return Math.max(this.totalCount - this.selectedCount, 0);
    },
  },

  methods: {
    ...mapActions("rentAdjustment", ["fetchPaymentPreviewSchema"]),
    ...mapMutations("rentAdjustment", {
      setUnitLesseeTag: "SET_UNIT_LEASE_TAG",
    }),
    resetModalForm() {
      this.tagOption = "old";
      this.applyToAll = false;
    },
    handleChangeTag() {
      $("#modalChangePaymentTag").modal("show");
    },
    setOrderTag(tagData) {
      return this.orders.map((order) => {
        if (this.applyToAll) {
          return {
            orderCode: order.orderCode,
            leaseTag: tagData,
          };
        }

        return {
          orderCode: order.orderCode,
          leaseTag: order.checked ? tagData : order.leaseTag,
        };
      });
    },
    async submit() {
      let tagResult = null;
      // If user choose "Atur Sendiri", then submit the form to get the tag data
      if (this.tagOption === "custom") {
        tagResult = await this.$refs.orderTagFormRef.submitOrderTag();
        if (!tagResult) {
          return;
        }
      }
      if (tagResult && tagResult.tag) {
        tagResult.tag = tagResult.tag.map((el) => el.tagId);
      }
      const updatedOrders = this.setOrderTag(tagResult);
      this.setUnitLesseeTag(updatedOrders);
      const selectedCount = this.selectedCount;
      try {
        const response = await this.fetchPaymentPreviewSchema();
        if (!response.isSuccess) {
          return alert().fire({
            icon: "error",
            title: "Gagal update tag",
            text: response.message || "Terjadi kesalahan saat update tag",
            confirmButtonText: "Oke",
            customClass: {
              confirmButton: "btn btn-primary btn-confirm-custom-pps",
              actions: "swal2-actions-custom-pps",
            },
          });
        }
        $("#modalChangePaymentTag").modal("hide");
        let alertDesc = "";
        if (this.applyToAll) {
          alertDesc += `untuk ${this.totalCount} order (semua order)`;
        } else {
          alertDesc += `untuk ${selectedCount} order terpilih`;
        }
        if (this.tagOption === "old") {
          alertDesc = `<strong>Ikuti tag order lama</strong> ${alertDesc} kembali memakai aturan tag masing-masing sebelum pindah.`;
        } else {
          alertDesc = `<strong>Atur sendiri</strong> ${alertDesc} kini memakai tag <strong>${this.displayedTag(
            tagResult
          )}</strong>`;
        }
        await alert().fire({
          icon: "success",
          title: "Tag pembayaran berhasil diterapkan",
          html: alertDesc,
          confirmButtonText: "Oke",
          customClass: {
            confirmButton: "btn btn-primary btn-confirm-custom-pps",
            actions: "swal2-actions-custom-pps",
          },
        });
        this.resetModalForm();
      } catch (error) {}
    },
  },
};
</script>

<style scoped>
/* Tidak mengatur font-family, mengikuti default halaman/Bootstrap */

.payment-tag-modal {
  border-radius: 14px;
  border: none;
  box-shadow: 0 20px 45px rgba(0, 0, 0, 0.18);
  overflow: hidden;
}

.modal-header-custom {
  padding: 20px 20px 12px 20px;
  border: none;
}

.modal-title-custom {
  font-size: 18px;
  font-weight: 700;
  color: #1f2430;
}

.modal-subtitle-custom {
  font-size: 13.5px;
  color: #8a8f99;
  margin-top: 4px;
}

.close-btn {
  border: none;
  background: transparent;
  color: #6b7280;
  padding: 2px;
  cursor: pointer;
  line-height: 0;
  flex-shrink: 0;
}
.close-btn:hover {
  color: #1f2430;
}

.dashed-divider {
  border: none;
  border-top: 1.5px dashed #d7dae0;
  margin: 0 20px;
}

.modal-body-custom {
  padding: 16px 20px;
}

.option-card {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  border: 1.5px solid #e2e5ea;
  border-radius: 10px;
  padding: 14px;
  margin-bottom: 12px;
  cursor: pointer;
  transition: border-color 0.15s ease, background-color 0.15s ease;
}
.option-card:last-of-type {
  margin-bottom: 16px;
}
.option-card:hover {
  border-color: #93c5fd;
}
.option-card--selected {
  border-color: #3b82f6;
  background: #eff6ff;
}

.option-radio {
  position: absolute;
  opacity: 0;
  width: 0;
  height: 0;
}

.radio-visual {
  width: 18px;
  height: 18px;
  border-radius: 50%;
  border: 1.5px solid #c7cad1;
  background: #fff;
  flex-shrink: 0;
  margin-top: 1px;
  position: relative;
  transition: border-color 0.15s ease;
}
.option-card--selected .radio-visual {
  border-color: #3b82f6;
}
.option-card--selected .radio-visual::after {
  content: "";
  position: absolute;
  inset: 3px;
  border-radius: 50%;
  background: #3b82f6;
}

.option-text {
  display: flex;
  flex-direction: column;
  gap: 3px;
}

.option-title {
  font-size: 14.5px;
  font-weight: 700;
  color: #1f2430;
}

.option-desc {
  font-size: 12.5px;
  color: #8a8f99;
}

.apply-all-row {
  display: flex;
  align-items: center;
  gap: 10px;
  border: 1.5px solid #e2e5ea;
  border-radius: 10px;
  padding: 12px 14px;
  cursor: pointer;
  transition: border-color 0.15s ease, background-color 0.15s ease;
}
.apply-all-row--checked {
  border-color: #3b82f6;
}

.apply-all-checkbox {
  position: absolute;
  opacity: 0;
  width: 0;
  height: 0;
}

.checkbox-visual {
  width: 18px;
  height: 18px;
  border-radius: 5px;
  border: 1.5px solid #c7cad1;
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  transition: background-color 0.15s ease, border-color 0.15s ease;
}
.apply-all-row--checked .checkbox-visual {
  background: #3b82f6;
  border-color: #3b82f6;
}

.apply-all-text {
  font-size: 13.5px;
  font-weight: 600;
  color: #1f2430;
}

.info-box {
  font-size: 12.5px;
  font-weight: 500;
  border-radius: 8px;
  padding: 10px 14px;
  margin-top: 10px;
}

.info-box--success {
  background: #eafaf0;
  color: #1a7f4e;
}

.info-box--warning {
  background: #fef6e0;
  color: #a56b0a;
}

.modal-footer-custom {
  padding: 14px 20px 20px 20px;
  border: none;
}

.btn-outline-secondary-custom {
  border: 1.5px solid #d7dae0;
  color: #4b5563;
  background: #fff;
  border-radius: 8px;
  padding: 8px 18px;
  font-size: 13.5px;
  font-weight: 600;
}
.btn-outline-secondary-custom:hover {
  background: #f7f8fa;
}

.btn-primary-custom {
  border: 1.5px solid #2563eb;
  background: #2f6ff0;
  color: #fff;
  border-radius: 8px;
  padding: 8px 18px;
  font-size: 13.5px;
  font-weight: 600;
}
.btn-primary-custom:hover {
  background: #1d4ed8;
}
</style>
<style>
.btn-confirm-custom-pps {
  background: #1d4ed8;
  width: 100%;
}
.swal2-actions-custom-pps {
  width: 100%;
  padding: 0 40px;
}
</style>


// WEBPACK FOOTER //
// src/components/RentAdjustment/CustomComponent/PaymentPreview/ChangePaymentTagModal.vue